<template>
  <div class="blank-page">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'blank-page',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.blank-page {
  width: 100%;
  height: 100%;
}
</style>